import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { StripeService } from "../../../services/stripe.service";
import { first } from 'rxjs/internal/operators/first';
import { OrganisationService } from "../../../services/organisation.service";
import { AuthService } from "../../../services/auth.service";
import { UserService } from "../../../services/user.service";
import { environment } from 'src/environments/environment';
import {Role, User} from "../../../models";
import { LocationStrategy } from '@angular/common';

// stripe variable
declare var Stripe: any;

@Component({
  selector: 'payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {

  stripeKey: any;
  stripe: any;
  loading = false;
  routerParam: string;
  hideRedirect = false;
  disabledLink = true;
  paymentError = false;
  plan_price: string;
  delivery_country: string;
  delivery_charge: string;
  showDeviceDelivery: any;
  voucherCode: string;
  card: any;
  voucherError = false;
  voucherErrorMessage = "Your voucher has expired. Please subscribe or enter a new voucher code to continue.";
  disableBtn = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageTitleService: Title,
    private stripeService: StripeService,
    private userService: UserService,
    private organisationService: OrganisationService,
    private authService: AuthService,
    private location: LocationStrategy
  ) {
    // preventing back button in browser
    history.pushState(null, null, '/payment-method');
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  handler: any = null;

  ngOnInit(): void {
    this.setPageTitle();
    this.showDeviceDelivery = environment.includeDeviceDelivery;
    window.scrollTo(0,0);
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Payment Method');
    this.getRouteParameters();
  }

  getRouteParameters() {
    if (window.history.state && window.history.state.hasOwnProperty('email')) {
      this.routerParam = window.history.state.email;
    }

    if (window.history.state && window.history.state.hasOwnProperty('from')) {
      this.hideRedirect = (window.history.state.from == 'sign-in') ? true : false;
    }

    if (window.history.state && window.history.state.hasOwnProperty('voucherError')) {
      this.voucherError = window.history.state.voucherError;
    }

    if (this.showDeviceDelivery) {
      this.getDeliveryAddress();
    } else {
      this.getPlanPrice();
    }
  }

  getPlanPrice() {
    this.userService.getPlanPrice()
      .pipe(first())
      .subscribe(
        data => {
          this.plan_price = data.data.plan_price;
          this.loadStripe();
        }
      );
  }

  getDeliveryAddress() {
    this.userService.getDeliveryAddress()
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data);
          this.delivery_country = data.data.delivery_country;
          this.delivery_charge = data.data.delivery_charge;
          this.plan_price = data.data.plan_price;
          this.loadStripe();
        }
      );
  }

  loadStripe() {
    this.stripeService.getStripeKey()
      .pipe(first())
      .subscribe(
        data => {
          this.stripeKey = data.data.key;
          this.stripe = Stripe(this.stripeKey);

          // Create `card` element that will watch for updates
          // and display error messages
          const style = {
            base: {
              color: '#32325d',
              lineHeight: '18px',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              },
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };

          // create the payment input box
          const elements = this.stripe.elements();
          this.card = elements.create('card', {
                      hidePostalCode: true,
                      style});
          this.card.mount('#card-element');

          // display error
          this.card.addEventListener('change', event => {
            const displayError = document.getElementById('card-errors');
            if (event.error) {
              displayError.textContent = event.error.message;
            } else {
              displayError.textContent = '';
            }
          });

          // focus on element upon load of page
          this.card.on('ready', () => {
              //card.focus();
          });

          // Listen for form submission, process the form with Stripe,
          // and get the token id
          /*
          const paymentForm = document.getElementById('payment-form');
          paymentForm.addEventListener('submit', event => {
              event.preventDefault();
              this.stripe.createToken(card).then(result => {
                //console.log(result);
                if (result.error) {
                  console.log('Error creating payment method.');
                  const errorElement = document.getElementById('card-errors');
                  errorElement.textContent = result.error.message;
                  this.loading = false;
                } else {
                  // At this point, you should send the token ID
                  // to your server so it can attach
                  // the payment source to a customer
                  // console.log('Token acquired!');
                  // console.log(result.token);
                  // console.log(result.token.id);
                  this.loading = true;
                  this.savePaymentMethod(result.token.id);
                }
              });
          });
          */
        },
        error => {
        });
  }

  // save payment method
  savePaymentMethod(token: string) {
    this.stripeService.savePaymentMethod(token)
      .pipe(first())
      .subscribe(data => {
        if (data.success) {
          this.getPaymentMethod();
        } else {
          this.paymentError = true;
          this.disableBtn = false;
          this.loading = false;
          setTimeout(() => {
            this.paymentError = false;
          }, 4000);
        }
      });
  }

  // get latest payment method
  getPaymentMethod() {
    this.stripeService.getPaymentMethod()
      .pipe(first())
      .subscribe(response => {
        if (response.data.methods.length > 0) {
          const paymentMethods = response.data.methods;
          const latest = paymentMethods[paymentMethods.length -  1];
          //console.log('payment method:', latest);
          if (this.showDeviceDelivery) {
            this.subscribe(latest.id);
          } else {
            this.subscribeWithoutDevice(latest.id);
          }
        }
      });
  }

  // subscribe
  subscribe(methodId: number) {
    this.stripeService.subscribe(methodId)
      .pipe(first())
      .subscribe(data => {
        if (data.success) {
          //console.log('You are subscribed!');
          this.router.navigate(['/user/dashboard']);
        }
        this.disableBtn = false;
        this.loading = false;
      });
  }

  subscribeWithoutDevice(methodId: number) {
    this.stripeService.subscribeWithoutDevice(methodId)
      .pipe(first())
      .subscribe(data => {
        if (data.success) {
          //console.log('You are subscribed!');
          this.router.navigate(['/user/dashboard']);
        }
        this.disableBtn = false;

        this.loading = false;
      });
  }

  redirectToDeliveryAddress() {
    this.router.navigateByUrl('/delivery-address', {state: {email: this.routerParam, from: 'payment-method'}});
  }

  onSubmit() {
    this.disableBtn = true;

    if (this.voucherCode) {
      // check voucher code
      this.loading = true;

      this.organisationService.checkVoucherUpdateUser(this.voucherCode)
        .pipe(first())
        .subscribe(data => {
          if (data.success) {

            // change user role to 'Employee' type
            const userDetails = {
              first_name: this.authService.currentUserValue.firstName,
              last_name: this.authService.currentUserValue.lastName,
              email: this.authService.currentUserValue.email,
              avatar: this.authService.currentUserValue.avatar,
              role: Role.Employee,
              is_subscribed: this.authService.currentUserValue.isSubscribed,
              points_earned: this.authService.currentUserValue.points,
            };
            this.authService.setUserData(userDetails);

            // redirect to user dashboard
            this.router.navigate(['/user/dashboard']);
          } else {
            this.voucherError = true;
            this.voucherErrorMessage = data.error.msg;
          }
          this.disableBtn = false;
          this.loading = false;
        });

    } else {
      // check subscription (stripe)
      // get the token id
      this.stripe.createToken(this.card).then(result => {
        //console.log(result);
        if (result.error) {
          //console.log('Error creating payment method.');
          const errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          this.disableBtn = false;
          this.loading = false;
        } else {
          // At this point, you should send the token ID
          // to your server so it can attach
          // the payment source to a customer
          // console.log(this.disableBtn);
          // console.log('Token acquired!');
          // console.log(result.token);
          // console.log(result.token.id);
          this.loading = true;
          this.savePaymentMethod(result.token.id);
        }
      });
    }
  }
}
